<section>
  <article>
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container *ngFor="let column of columns">
        <ng-container matColumnDef="{{column.id}}">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ column.libelle }}</th>
          <td mat-cell [ngClass]="element[column.id] | typeof" *matCellDef="let element" [attr.data-label]=column.libelle>{{ element[column.id] }}</td>
        </ng-container>
      </ng-container>
      <ng-container matColumnDef="voirPlus">
        <th mat-header-cell *matHeaderCellDef>Voir ID Vts KO</th>
        <td mat-cell *matCellDef="let row" data-label="Voir ID Vts KO">
          <a (click)="showCAB(row)" *ngIf="row.cabKO > 0">
            <mat-icon>visibility</mat-icon>
          </a>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </article>
  <mat-paginator [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
</section>
